/* eslint-disable */
export default {
  account: 'Conta',
  contact: 'Contato',
  lead: 'Cliente potencial',
  opportunity: 'Oportunidade',
  case: 'Caso',
  chooseEntity: 'Selec. o tipo de entidade',
  create: 'Criar',
} as const;

// @key: @#@"account"@#@ @source: @#@"Account"@#@
// @key: @#@"contact"@#@ @source: @#@"Contact"@#@
// @key: @#@"lead"@#@ @source: @#@"Lead"@#@
// @key: @#@"opportunity"@#@ @source: @#@"Opportunity"@#@
// @key: @#@"case"@#@ @source: @#@"Case"@#@
// @key: @#@"chooseEntity"@#@ @source: @#@"Please select entity type"@#@
// @key: @#@"create"@#@ @source: @#@"Create"@#@
